export default function() {
    let contactForms = Array.from(document.querySelectorAll(".form--contact"));

    contactForms.forEach(form => {
        form.addEventListener("freeform-ready", function(event) {
            var freeform = event.target.freeform;
            freeform.addOnSuccessfulAjaxSubmit((evt, form, response) => {
                var parent = form.parentNode;
                var message = parent.querySelector(".success-message");
                message.style.display = "block";
                parent.removeChild(form);
            });
        });
    });
}